// Maps markdown filenames to display metadata
// Order determines sidebar display order
const SUPPORT_DOCS = [
  { file: "CellCog_Getting_Started.md", title: "Getting Started", category: "Basics" },
  { file: "CellCog_Chat_Guide.md", title: "Chat", category: "Basics" },
  { file: "CellCog_Projects_Guide.md", title: "Projects & Agent Roles", category: "Basics" },
  { file: "CellCog_Memory_System_Guide.md", title: "Memory System & Context Trees", category: "Basics" },
  { file: "CellCog_Drive_Guide.md", title: "Drive", category: "Basics" },
  { file: "CellCog_Apps_Guide.md", title: "Apps Agents Build", category: "Basics" },
  { file: "CellCog_AI_Employees_Guide.md", title: "AI Employees", category: "AI Employees" },
  { file: "CellCog_Routines_Guide.md", title: "Routines", category: "AI Employees" },
  { file: "CellCog_Task_Board_Guide.md", title: "Task Board", category: "AI Employees" },
  { file: "CellCog_Cloud_Browsers_Guide.md", title: "Cloud Browsers", category: "AI Employees" },
  { file: "CellCog_Cold_Outreach_Guide.md", title: "Outreach", category: "AI Employees" },
  { file: "CellCog_Meetings_Guide.md", title: "Meetings", category: "AI Employees" },
  { file: "CellCog_Phone_Guide.md", title: "Phone", category: "AI Employees" },
  { file: "CellCog_Contacts_Guide.md", title: "Contacts", category: "AI Employees" },
  { file: "CellCog_Spend_Guide.md", title: "Spend", category: "AI Employees" },
  { file: "CellCog_Social_Guide.md", title: "Social", category: "AI Employees" },
  { file: "CellCog_Ads_Guide.md", title: "Ads", category: "AI Employees" },
  { file: "CellCog_Channels_Guide.md", title: "Channels & DMs", category: "AI Employees" },
  { file: "CellCog_Avatars_Guide.md", title: "Avatars", category: "Features" },
  { file: "CellCog_Cowork_Guide.md", title: "Cowork", category: "Features" },
  { file: "CellCog_Subagents_Guide.md", title: "Subagents", category: "Features" },
  { file: "CellCog_Browse_my_Chrome_Guide.md", title: "Browse my Chrome", category: "Features" },
  { file: "CellCog_Approvals_and_Safety_Guide.md", title: "Approvals & Safety", category: "Features" },

  { file: "CellCog_Connectors_Guide.md", title: "Connectors & Tools", category: "Integrations" },
  { file: "CellCog_OpenClaw_Guide.md", title: "OpenClaw Integration", category: "Integrations" },
  { file: "CellCog_Linear_Integration_Guide.md", title: "Linear Integration", category: "Integrations" },
  { file: "CellCog_Plugin_Guide.md", title: "Coding Agent Plugin", category: "Integrations" },
  { file: "CellCog_MCP_Connector_Guide.md", title: "MCP Connector", category: "Integrations" },
  { file: "CellCog_API_Keys_Guide.md", title: "API Keys", category: "Integrations" },
  { file: "CellCog_Billing_Guide.md", title: "Billing & Credits", category: "Account" },
  { file: "CellCog_Organization_Guide.md", title: "Organization", category: "Account" },
  { file: "CellCog_Referrals_Guide.md", title: "Referrals", category: "Account" },
  { file: "CellCog_Product_Overview.md", title: "Product Overview", category: "About" },
  { file: "CellCog_How_We_Use_It.md", title: "How CellCog Uses CellCog", category: "About" },
  { file: "CellCog_Terms_of_Service.md", title: "Terms of Service", category: "Legal" },
  { file: "CellCog_Privacy_Policy.md", title: "Privacy Policy", category: "Legal" },
];

// Generate slug from filename: CellCog_Getting_Started.md -> getting-started
export const fileToSlug = (filename) => {
  return filename
    .replace(/^CellCog_/, '')
    .replace(/\.md$/, '')
    .replace(/_/g, '-')
    .toLowerCase();
};

// Reverse: getting-started -> CellCog_Getting_Started.md
export const slugToFile = (slug) => {
  const doc = SUPPORT_DOCS.find(d => fileToSlug(d.file) === slug);
  return doc ? doc.file : null;
};

// Get all unique categories in order
export const getCategories = () => {
  const seen = new Set();
  return SUPPORT_DOCS.reduce((cats, doc) => {
    if (!seen.has(doc.category)) {
      seen.add(doc.category);
      cats.push(doc.category);
    }
    return cats;
  }, []);
};

export default SUPPORT_DOCS;
